// 成员操作
const mutations = {
  setUserMenu(state, val) {
    state.user_menu = val;
  },
  setUserPermission(state, val) {
    state.userPermission = val;
  },
  setSpinning(state, val) {
    state.spinning = val;
  },
};
export default mutations;
